import { Col, List, Row, Table } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ResponseDetails = ({ responseData }) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const handleExpand = (record) => {
    if (expandedRowKeys.includes(record._id)) {
      setExpandedRowKeys([]);
    } else {
      const keys = [];
      keys.push(record._id);
      setExpandedRowKeys(keys);
    }
  };

  const columns = [
    {
      title: 'Word Key',
      dataIndex: 'wordKey',
      key: 'wordKey',
      align: 'left',
      width: '50%',
      render: (text, record) => <div onClick={() => handleExpand(record)}>{text}</div>,
    },
    {
      title: 'Word Value',
      dataIndex: 'wordValue',
      key: 'wordValue',
      align: 'left',
      width: '50%',
      render: (text, record) => <div onClick={() => handleExpand(record)}>{text}</div>,
    },
  ];

  let records = responseData?.failedRecords || [];
  let updatedRecords = records.map((record, i) => ({
    ...record,
    _id: i,
    wordKey: record['word-key'],
    wordValue: record['word-value'],
  }));

  return (
    <Row>
      <Col span={24} className="heading-col">
        <Row align="middle" gutter={[0, 0]}>
          <Col>
            <div>
              <span className="heading-span">Failed Records Details</span>
            </div>
          </Col>
        </Row>
      </Col>

      <Col span={24}>
        <Row justify="center">
          <Col span={24} style={{ marginBottom: '30px' }}>
            <Table
              className="special-table"
              style={{
                marginTop: '0px',
              }}
              columns={columns}
              pagination={false}
              scroll={{ x: 'max-content' }}
              expandable={{
                expandedRowRender: (record) => {
                  return (
                    <Col span={24}>
                      <List
                        size="small"
                        header={null}
                        footer={null}
                        bordered
                        dataSource={[record.wordValue]}  // Display word value when expanded
                        renderItem={(item) => <List.Item>{item}</List.Item>}
                      />
                    </Col>
                  );
                },
                expandRowByClick: true,
                expandedRowKeys: expandedRowKeys,
                onExpand: (expanded, record) => {
                  const keys = [];
                  if (expanded) {
                    keys.push(record._id);
                  }
                  setExpandedRowKeys(keys);
                },
              }}
              dataSource={updatedRecords}
              rowKey={(record) => record._id}
              rowClassName="editable-row"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ResponseDetails;
